import React from 'react';

import { useRoutes } from 'react-router-dom';
import Make from './Make';
import Model from './Model';
import Form from './Form';
import Confirm from './Confirm';
import QueryComponent from './QueryComponent';

export default function BuilderRoutes({
	nextStepLink,
	setCurrentStep,
	rootDir
}) {
	return useRoutes([
		// default
		{
			path: '/',
			element: (
				<Make
					nextStepLink={nextStepLink}
					setCurrentStep={setCurrentStep}
				/>
			)
		},
		{
			path: `${rootDir}/index.htm`,
			element: (
				<Make
					nextStepLink={nextStepLink}
					setCurrentStep={setCurrentStep}
				/>
			)
		},
		{
			path: `${rootDir}/:make.htm`,
			element: (
				<Model
					nextStepLink={nextStepLink}
					setCurrentStep={setCurrentStep}
				/>
			)
		},
		{
			path: `${rootDir}/:make/:model.htm`,
			element: <QueryComponent setCurrentStep={setCurrentStep} />
		},
		{
			path: `${rootDir}/:make/:model/form.htm`,
			element: <Form setCurrentStep={setCurrentStep} />
		},
		{
			path: `${rootDir}/:make/:model/confirm.htm`,
			element: <Confirm setCurrentStep={setCurrentStep} />
		}
	]);
}
